import React, { Component } from "react";
import PropTypes from "prop-types";
import { loadApi, getPmBalloonData } from "../helpers/core";
import Preloader from "./Preloader";

const clientIcon = require("../assets/images/client-icon.png");
const supplierIcon = require("../assets/images/supplier-icon.png");
const elevatorIcon = require("../assets/images/elevator-icon.png");

let activeCl = null;
const typeStrings = {
  client: "Клиент",
  supplier: "Поставщик",
  elevator: "Элеватор"
};
export default class YMap extends Component {
  constructor() {
    super();

    this.initMap = this.initMap.bind(this);

    this.api =
      typeof window != "undefined" && !!window.ymaps ? window.ymaps : null;
  }

  componentDidMount() {
    this.api
      ? this.initMap()
      : loadApi(this.props.options).then(instance => {
          this.api = instance;
          this.initMap();
        });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.placemarks.length &&
      this.props.placemarks !== nextProps.placemarks &&
      !nextProps.isFetching &&
      this.api
    ) {
      if (!this.mapInstance) {
        this.initMap();
      }
      this.mapInstance.geoObjects.removeAll();
      nextProps.isAddressSaveAvalable
        ? this.renderSearchResult(nextProps.placemarks[0])
        : this.renderPlacemarks(nextProps.placemarks);
    }
  }

  initMap() {
    const {
      zoom,
      center,
      controls,
      placemarks,
      isAddressSaveAvalable,
      coords
    } = this.props;

    if (this.api.Map && this.map) {
      this.mapInstance = new this.api.Map(this.map, {
        center,
        zoom,
        controls
      });

      this.mapInstance.options.set("minZoom", 3);
      this.mapInstance.options.set("maxZoom", 14);

      if (isAddressSaveAvalable) {
        if (placemarks[0]) {
          this.renderSearchResult(placemarks[0]);
        }
      } else {
        this.renderPlacemarks(placemarks);
      }
    }
  }

  renderSearchResult = placemark => {
    const pm = new this.api.Placemark(
      placemark.coords,
      {
        hasBalloon: false
      },
      {
        iconContent: "islands#violetDotIcon"
      }
    );
    this.mapInstance.geoObjects.removeAll();
    this.mapInstance.geoObjects.add(pm);
    const bounds = this.mapInstance.geoObjects.getBounds();
    this.mapInstance.setBounds(bounds, {
      checkZoomRange: true
    });
  };

  getPmData = type => {
    switch (type) {
      case "elevator":
        return { icon: elevatorIcon, type: typeStrings[type] };
      case "supplier":
        return { icon: supplierIcon, type: typeStrings[type] };
      case "client":
        return { icon: clientIcon, type: typeStrings[type] };
      default:
        return {};
    }
  };

  getContentBody = (id, cb) => {
    getPmBalloonData(id).then(response => {
      if (response.success && response.code === 200) {
        cb(response.data);
      }
    });
  };

  getId = (dataLogger, object) => {
    return object.getAll().id;
  };

  getTitle = (dataLogger, object) => {
    return object.getAll().balloonContentTitle;
  };

  getContent = (dataLogger, object) => {
    const content = object.getAll().balloonContentBody;
    return content
      ? `<div class="pm-detail-info"><a href="javascript:void(0)" class="back-link text-primary js-back-link"><- Перейти к списку</a><h4 class="pm-title">${
          object.getAll().balloonContentHeader
        }</h4>${content}</div>`
      : null;
  };

  renderPlacemarks(placemarks) {
    if (placemarks.length && this.api.Clusterer) {
      let be_restored_row = null;

      // Создаем собственный макет с информацией о выбранном геообъекте.
      this.api.template.filtersStorage.add("id", this.getId);
      this.api.template.filtersStorage.add("title", this.getTitle);
      this.api.template.filtersStorage.add("content", this.getContent);
      var _self = this;
      /* eslint-disable indent */
      var customBalloonContentLayout = this.api.templateLayoutFactory.createClass(
        [
          '<div class="flex stretch">',
          '<div class="aside-nav">',
          "{% for key, value in properties.types %}",
          "{% if key == properties.activeType %}",
          '<div class="\'js-balloon-nav aside-nav__item active" data-type={{key}}>{{ value.string }} <span class="label label-info">{{ value.count }}</span></div>',
          "{% else %}",
          '<div class="\'js-balloon-nav aside-nav__item" data-type={{key}}>{{ value.string }} <span class="label label-info">{{ value.count }}</span></div>',
          "{% endif %}",
          "{% endfor %}",
          "</div>",
          '<ul class="balloon-list js-balloon-list">',
          "{% for typesObject in properties.typesObjects %}",
          '<li class="js-balloon-item balloon-list__item" data-id={{typesObject.properties|id}}>{{typesObject.properties|title}}</li>',
          "<li>{{typesObject.properties|content|raw}}</li>",
          "{% endfor %}",
          "</ul>",
          "</div>"
          /* eslint-enable indent */
        ].join(""),
        {
          build: function() {
            customBalloonContentLayout.superclass.build.call(this);
            const geoObjects = this.getData().properties.get("geoObjects");
            const listNode = document.querySelector(".js-balloon-list");
            let currentPm =
              geoObjects.find(pm => pm.properties.get("loaded") == true) ||
              null;
            if (listNode) {
              currentPm
                ? listNode.classList.add("with-overblock")
                : listNode.classList.remove("with-overblock");
            }

            const cb = e => {
              const node = e.getSourceEvent().originalEvent.target;
              if (
                node &&
                node.classList.value.indexOf("js-balloon-nav") !== -1
              ) {
                const type = node.dataset.type;
                const typesObjects = geoObjects.filter(
                  o => o.properties.get("type") == type
                );
                activeCl.properties.set("typesObjects", typesObjects);
                activeCl.properties.set("activeType", type);
                this.rebuild();
              }

              if (currentPm) {
                currentPm.properties.set("balloonContentHeader", null);
                currentPm.properties.set("balloonContentBody", null);
                currentPm.properties.set("loaded", false);
              }
              if (
                node &&
                node.classList.value.indexOf("js-balloon-item") !== -1
              ) {
                const id = node.dataset.id;
                const pm = geoObjects.find(p => p.properties.get("id") == id);

                be_restored_row = id;

                currentPm = pm;
                _self.getContentBody([id], data => {
                  const pm = geoObjects.find(p => p.properties.get("id") == id);
                  pm.properties.set(
                    "balloonContentHeader",
                    data.descriptions[0].title
                  );
                  pm.properties.set(
                    "balloonContentBody",
                    data.descriptions[0].description
                  );
                  pm.properties.set("loaded", true);
                  this.rebuild();
                });
              }

              if (node && node.classList.value.indexOf("js-back-link") !== -1) {
                currentPm.properties.set("balloonContentHeader", null);
                currentPm.properties.set("balloonContentBody", null);
                currentPm.properties.set("loaded", false);
                this.rebuild();

                let be_restored_row_pos = document.querySelector(
                  `[data-id="${be_restored_row}"]`
                );
                if (be_restored_row_pos !== null)
                  be_restored_row_pos.scrollIntoView();
              }
            };

            if (
              !this.events.types.click ||
              !this.events.types.click.find(
                f => typeof f === "function" && f.name == "cb"
              )
            ) {
              this.events.add("click", cb);
            }
          }
        }
      );

      this.clusterer = new this.api.Clusterer({
        clusterDisableClickZoom: true,
        clusterOpenBalloonOnClick: true,
        // Устанавливаем режим открытия балуна.
        // В данном примере балун никогда не будет открываться в режиме панели.
        clusterBalloonPanelMaxMapArea: 0,
        clusterBalloonMaxHeight: 200,
        clusterBalloonMaxWidth: 350,
        clusterBalloonMinWidth: 250,
        clusterBalloonMinHeight: 200,
        // Устанавливаем собственный макет контента балуна.
        clusterBalloonContentLayout: customBalloonContentLayout
      });

      this.clusterer.createCluster = function(center, geoObjects) {
        // Создаем метку-кластер с помощью стандартной реализации метода.
        var clusterPlacemark = ymaps.Clusterer.prototype.createCluster.call(
          this,
          center,
          geoObjects
        );
        clusterPlacemark.events.add("click", function() {
          activeCl = clusterPlacemark;
          var geoobj = clusterPlacemark.getGeoObjects();
          var types = {};
          var activeType = "";
          geoobj.forEach(function(obj, key) {
            var type = obj.properties.get("type");
            if (key === 0) {
              activeType = type;
            }
            if (types[type]) {
              types[type].count += 1;
            } else {
              types[type] = {
                string: typeStrings[type],
                count: 1
              };
            }
          });
          activeCl.properties.set("types", types);
          activeCl.properties.set("activeType", activeType);
          var typesObjects = geoobj.filter(
            o => o.properties.get("type") == activeType
          );
          activeCl.properties.set("typesObjects", typesObjects);
        });
        return clusterPlacemark;
      };

      const geoObjects = placemarks.map(pm => {
        const data = this.getPmData(pm.type);
        const placemark = new this.api.Placemark(
          pm.coords,
          {
            balloonContentTitle: pm.name,
            loaded: false,
            id: pm.id,
            type: pm.type
          },
          {
            iconLayout: "default#image",
            iconImageHref: data.icon,
            iconImageSize: [20, 20],
            iconImageOffset: [-10, -10]
          }
        );

        placemark.events.add("click", () => {
          if (!placemark.properties.get("balloonContentBody")) {
            this.getContentBody([pm.id], data => {
              placemark.properties.set(
                "balloonContentHeader",
                data.descriptions[0].title
              );
              placemark.properties.set(
                "balloonContentBody",
                data.descriptions[0].description
              );
              placemark.properties.set("loaded", true);
              placemark.balloon.open();
            });
          } else {
            placemark.balloon.open();
          }
        });

        return placemark;
      });

      this.clusterer.add(geoObjects);
      this.mapInstance.geoObjects.add(this.clusterer);

      this.mapInstance.setBounds(this.clusterer.getBounds(), {
        checkZoomRange: true
      });
    }
  }

  render() {
    // console.log("PLACEMARK FROM YMAP ", this.props.placemarks);
    // console.log("COORDS FROM YMAP ", this.props.coords);

    return (
      <div className="map-container">
        {this.props.isFetching && <Preloader isInContainer />}
        <div
          ref={c => {
            this.map = c;
          }}
          className="map"
        />
      </div>
    );
  }
}

YMap.propTypes = {
  options: PropTypes.object,
  center: PropTypes.array,
  zoom: PropTypes.number,
  controls: PropTypes.array,
  placemarks: PropTypes.array,
  isFetching: PropTypes.bool,
  isAddressSaveAvalable: PropTypes.bool
};

YMap.defaultProps = {
  options: {
    lang: "ru_RU",
    coordorder: "latlong",
    load: "package.full",
    mode: "release"
  },
  center: [54.312416, 48.395622],
  zoom: 12,
  placemarks: []
};



// WEBPACK FOOTER //
// ./components/Map.js